export default __webpack_public_path__ + "static/media/treeIconType_lightBorder_color.0d703181.svg";